import { InlineMessage } from "@repo/ui/inline-message";
import { useStore } from "@repo/ui/store";
import { InfoRound } from "@/theme/icons/info-round";
import { TYPOGRAPHY_BODY3_SENTENCE } from "@/theme/topshop/typography/typography-constants";

// TODO: temporary solution until we have more clarity on how sitecore integration will work
const URLS: Record<string, string> = {
  GB: "https://www.asos.com/customer-care/technical/im-having-trouble-signing-into-my-account/", // TODO: replace with the correct URL
};

export const IdentityErrorMessage = () => {
  const { countryData } = useStore();

  const url = URLS[countryData.storeCode] ?? URLS["GB"]!;

  return (
    <InlineMessage
      appearance="bordered"
      icon={<InfoRound />}
      inlineMessageClass={TYPOGRAPHY_BODY3_SENTENCE}
    >
      Oops! Something's gone wrong and the chat can't load. Please check the
      below and try again:
      <br />
      Make sure your device clock is accurate and not fast. You can fix this by
      setting the time on your device to default.
      <br />
      Check the 'Block Cookies' function is disabled in your browser settings.
      <br />
      Check you don't have any content blockers installed.
      <br />
      Make sure Javascript is enabled in your browser's settings.
      <br />
      <a href={url} style={{ textDecoration: "underline" }}>
        Get more help with logging in to your account.
      </a>
    </InlineMessage>
  );
};
